export default __webpack_public_path__ + "static/media/csv.7a98408b.png";